import { StateSelector } from '@integration-frontends/common/utils/redux';
import { Section } from '@integration-frontends/integration/core/model';
import { EntityState } from '@reduxjs/toolkit';
import { sectionAdapter } from '../entities';

export function createSectionSelectors(stateSelector: StateSelector<EntityState<Section>>) {
  return sectionAdapter.getSelectors(stateSelector);
}
